/* global angular  */

export default [
  '$animate',
  'uiStateManagerService',
  'uiStateManagerHistoryService',
  directive,
]

const NG_SHOW_CLASS = 'ng-show'
const NG_SHOW_IN_PROGRESS_CLASS = 'ng-show-animate'

const NG_HIDE_CLASS = 'ng-hide'
const NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate'

function directive(
  $animate,
  uiStateManagerService,
  uiStateManagerHistoryService
) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      const toBeDestroyed = []
      /*
       * When active, hide.
       * When disabled, show.
       */
      let uiHide = attr.uiStateManagerHideState || 'active'
      let uiShow = attr.uiStateManagerShowState || 'disabled'
      // Little syntactic sugar to make the API taste better.
      let uiReversed = attr.uiStateManagerReversed || false
      if (angular.isString(uiReversed)) {
        uiReversed = scope.$eval(uiReversed)
      }
      if (uiReversed) {
        uiHide = attr.uiStateManagerShowState || 'disabled'
        uiShow = attr.uiStateManagerHideState || 'active'
        element.addClass(NG_HIDE_CLASS)
        scope.currentViewState = 'disabled'
      } else {
        element.addClass(NG_SHOW_CLASS)
        scope.currentViewState = 'active'
      }
      scope.$on('$destroy', function() {
        for (let idx = 0; idx < toBeDestroyed.length; idx++) {
          toBeDestroyed[idx]()
        }
      })
      // Tasty
      const onStateChangeWatch = function onStateChangeWatch(payload) {
        $animate[payload['state'] === uiShow ? 'removeClass' : 'addClass'](
          element,
          NG_SHOW_CLASS,
          {
            tempClasses: NG_SHOW_IN_PROGRESS_CLASS,
          }
        ).then(function showAnimationCallback() {
          scope.currentViewState = 'active'
        })
        $animate[payload['state'] === uiHide ? 'addClass' : 'removeClass'](
          element,
          NG_HIDE_CLASS,
          {
            tempClasses: NG_HIDE_IN_PROGRESS_CLASS,
          }
        ).then(function hideAnimationCallback() {
          scope.currentViewState = 'disabled'
        })
      }
      toBeDestroyed.push(
        uiStateManagerService.onStateChange(
          attr.uiStateManager,
          onStateChangeWatch
        )
      )
      uiStateManagerHistoryService.replayHistory(
        attr.uiStateManager,
        onStateChangeWatch
      )
    },
  }
}
